const Header = {
  el: {
    root: document.querySelector<HTMLElement>('.header'),
    header: document.querySelector<HTMLElement>('.header'),
    content: document.querySelector<HTMLElement>('.header__content'),
    trigger: document.querySelector<HTMLButtonElement>('.header__trigger'),
    close: document.querySelector<HTMLButtonElement>('.header__close'),
    links: document.querySelectorAll<HTMLAnchorElement>('.header__nav-link'),
  },
  init() {
    // this.el.trigger.addEventListener('click', e => {
    //   this.openMenu()
    // })
    // this.el.close.addEventListener('click', e => {
    //   this.closeMenu()
    // })

    // this.handleTimeout()
  },

  openMenu() {
    this.el.header.classList.toggle('open')
    sessionStorage.setItem('menuOpened', JSON.stringify(true))
  },

  closeMenu() {
    this.el.header.classList.toggle('open')
  },

  handleTimeout() {
    if (!JSON.parse(window.sessionStorage.getItem('menuOpened'))) {
      this.el.root.classList.add('open')

      setTimeout(() => {
        if (this.el.root.classList.contains('open')) {
          this.el.root.classList.remove('open')
        }

        sessionStorage.setItem('menuOpened', JSON.stringify(true))
      }, 3000);
    }
}
}

export default Header
